
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"1.2","stroke-linecap":"round","stroke-linejoin":"round"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":"16","y":"21","width":"13","height":"14","rx":"2","transform":"rotate(180 16 21)"}}),_c('path',{attrs:{"d":"M8 7V5a2 2 0 012-2h9a2 2 0 012 2v10a2 2 0 01-2 2h-3M10 14H7M12 17H7M12 11H7"}})])
          )
        }
      }
    